import Ws from "../../providers/Ws";
import Utils from "../../providers/Utils";

export default class FromServer {

    getInfoProiect = async (id) => {


        let ws = new Ws();


        let getInfoProiect = await ws.customSelect('select * from proiecte where id = @p1', {
            p1: id
        })



        if (getInfoProiect.Succes) {
            return getInfoProiect.Content
        }
    }



    getDocumente = async () => {
        let ws = new Ws();


        let getDocumente = await ws.customSelect('select * from proiecte_documente where isnull(sters,0) != 1', {
            p1: 1
        })

        if (getDocumente.Succes) {
            return getDocumente
        }
    }

    getDocumenteTask = async (id) => {
        let ws = new Ws();

        let getDocumente = await ws.customSelect('select * from taskuri_documente where id_task = @p1 and isnull(sters,0) != 1', {
            p1: id
        })

        console.log('getDocumente :>> ', getDocumente);

        if (getDocumente.Succes) {
            return getDocumente
        }
    }

    getDocumenteEtapa = async (id) => {
        let ws = new Ws();

        let getDocumente = await ws.customSelect('select * from etape_documente where id_etapa = @p1 and isnull(sters,0) != 1', {
            p1: id
        })

        if (getDocumente.Succes) {
            return getDocumente
        }
    }

    getBugeteCosturiTipuri = async (idProiect) => {

        let ws = new Ws();

        let _bugete = ws.customSelect('select * from bugete_tipuri where isnull(inactiv,0) != 1 order by id desc', {
            p1: idProiect
        });

        let _costuri = ws.customSelect('select * from proiecte_costuri_tipuri where isnull(inactiv,0) != 1 order by id desc', {
            p1: idProiect
        })



        let [bugeteT, costuriT] = await Promise.all([_bugete, _costuri]);


        //console.log('bugete :', bugeteT);

        if (bugeteT.Succes && costuriT.Succes) {

            let obj = { bugeteT: bugeteT.Content, costuriT: costuriT.Content }

            return obj
        }

    }

    getBugetProiect = async (idProiect) => {
        let ws = new Ws();

        // let _bugete =  ws.customSelect('select p.*, b.* from proiecte_bugete p left outer join bugete_tipuri b on (p.id_tip = b.id) where p.id_proiect = @p1 order by p.id desc',{
        //     p1:idProiect
        // });

        // let _costuri = ws.customSelect('select p.*, c.* from proiecte_costuri p left outer join proiecte_costuri_tipuri c on (p.id_tip = c.id) where p.id_proiect = @p1 order by p.id desc',{
        //     p1:idProiect
        // })

        let buget = await ws.customSelect('select * from proiecte_bugete where id_proiect = @p1 ', {
            p1: idProiect
        })





        // console.log('bugete :', e);
        // console.log('c :', c);

        console.log('buget :>> ', buget);
        if (buget.Succes) {

           return  buget
        }
    }


    getBugeteEtape = async (idProiect) => {
        let ws = new Ws();

        // let _bugete =  ws.customSelect('select p.*, b.* from proiecte_bugete p left outer join bugete_tipuri b on (p.id_tip = b.id) where p.id_proiect = @p1 order by p.id desc',{
        //     p1:idProiect
        // });

        // let _costuri = ws.customSelect('select p.*, c.* from proiecte_costuri p left outer join proiecte_costuri_tipuri c on (p.id_tip = c.id) where p.id_proiect = @p1 order by p.id desc',{
        //     p1:idProiect
        // })

        let etape = ws.customSelect('select * from proiecte_etape where id_proiect = @p1 and isnull(inactiv,0) != 1', {
            p1: idProiect
        })

        let costuri = ws.customSelect('select * from bugete_etape where id_etapa in (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv,0) != 1) and isnull(sters,0) !=1', {
            p1: idProiect
        })

        let [e, c] = await Promise.all([etape, costuri]);


        // console.log('bugete :', e);
        // console.log('c :', c);

        if (e.Succes && c.Succes) {

            let obj = { etape: e.Content, costuri: c.Content }

            return obj
        }
    }


    getBugeteCosturi = async (idProiect) => {
        let ws = new Ws();

        // let _bugete =  ws.customSelect('select p.*, b.* from proiecte_bugete p left outer join bugete_tipuri b on (p.id_tip = b.id) where p.id_proiect = @p1 order by p.id desc',{
        //     p1:idProiect
        // });

        // let _costuri = ws.customSelect('select p.*, c.* from proiecte_costuri p left outer join proiecte_costuri_tipuri c on (p.id_tip = c.id) where p.id_proiect = @p1 order by p.id desc',{
        //     p1:idProiect
        // })

        let etape = ws.customSelect('select * from proiecte_etape where id_proiect = @p1 and isnull(inactiv,0) != 1', {
            p1: idProiect
        })

        let costuri = ws.customSelect('select * from costuri_etape where id_etapa in (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv,0) != 1) and isnull(sters,0) !=1', {
            p1: idProiect
        })

        let [e, c] = await Promise.all([etape, costuri]);


        // console.log('bugete :', e);
        // console.log('c :', c);

        if (e.Succes && c.Succes) {

            let obj = { etape: e.Content, costuri: c.Content }

            return obj
        }
    }

    insertBugetProiect = async (obj) => {
        let ws = new Ws();

        let insert = await ws.insert('proiecte_bugete', obj)

        //console.log('insert :', insert);

        if (insert.Succes) {
            return true
        }
    }

    updateBugetProiect = async (obj, id) => {
        let ws = new Ws();

        let update = await ws.update('proiecte_bugete', obj, id)

        if (update.Succes) {
            return true
        }
    }

    insertCostProiect = async (obj) => {
        let ws = new Ws();

        let insert = await ws.insert('proiecte_costuri', obj)

        //console.log('insert :', insert);

        if (insert.Succes) {
            return insert
        }
    }

    nrTaskuriByUser = async (idProiect) => {
        let ws = new Ws();

        let getNrTaskuri = await ws.customSelect(`select d.id_utilizator as id,  a.nume, a.poza, a.cost_minut, 
                                                       (select count(*) from taskuri where id_utilizator_responsabil = u.id ) as nr_taskuri_all ,
                                                       (select count(*) from taskuri where id_utilizator_responsabil = u.id and id_proiect = @p1 ) as nr_taskuri 
                                                        from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
                                                         left join angajati a on u.id = a.id_user where id_proiect = @p1 and
                                                         isnull(u.inactiv,0) !=1 `, {
            p1: idProiect
        })

        //console.log('getNrTaskuri :', getNrTaskuri);
        if (getNrTaskuri.Succes) {
            return getNrTaskuri.Content
        }
    }




    updateCostProiect = async (obj, id) => {
        let ws = new Ws();

        let update = await ws.update('proiecte_costuri', obj, id)

        //console.log('update :', update);

        if (update.Succes) {
            return true
        }
    }

    getUsers = async (idProiect) => {
        let ws = new Ws();

        let getUsers = await ws.customSelect(`select d.id as id_linie, d.doar_citire, d.nivel_responsabil, d.drepturi_extinse, d.id_utilizator as id ,
                                             a.nume, a.poza, a.cost_minut, u.email, u.firma, dep.nume as nume_departament from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
                                             left join angajati a on u.id = a.id_user 
                                             left join angajati_departamente ad on ad.id_angajat = a.id
                                             left join departamente dep on dep.id = ad.id_departament
                                             where d.id_proiect = @p1 and isnull(u.inactiv,0) != 1 and isnull(d.sters,0) != 1 order by isnull(d.nivel_responsabil,3) asc`, {
            p1: idProiect
        })

        // console.log('getUSers :', getUsers);
        if (getUsers.Succes) {
            return getUsers.Content
        }
    }

    getTaskuriTimpiLucru = async (idUser, idTask) => {
        let ws = new Ws();


        let getTimpiLucru = await ws.customSelect('select * from taskuri_timpi_lucru where id_user = @p1 and id_task = @p2 and isnull(sters,0) !=1', {
            p1: idUser,
            p2: idTask
        })

        if (getTimpiLucru.Succes) {
            return getTimpiLucru
        }
    }



    updateTaskuriTimpiLucru = async (cols, where) => {
        let ws = new Ws();

        let updateTimpi = await ws.update('taskuri_timpi_lucru', cols, where)



        if (updateTimpi.Succes) {
            return updateTimpi
        }
    }

    getAllUsers = async (idProiect) => {
        let ws = new Ws();


        let users = await ws.customSelect('select id, email, nume, firma from useri where id not in (select id_utilizator from proiecte_drepturi where id_proiect = @p1 and isnull(sters,0) != 1) and isnull(inactiv,0) !=1 ', {
            p1: idProiect
        })

        if (users.Succes) {
            return users.Content
        }
    }

    insertUserProject = async (obj) => {

        let ws = new Ws();

        let insert = await ws.insert('proiecte_drepturi', obj)

        if (insert.Succes) {
            return true
        }

    }

    updateUserProject = async (obj, where) => {
        let ws = new Ws();

        let update = await ws.update('proiecte_drepturi', obj, where)

        if (update.Succes) {
            return true
        }
    }

    getEtapeAll = async () => {
        let ws = new Ws();


        //    `select id, id_proiect, note, durata_de_la, durata_pana_la, id_user_responsabil, denumire, statusul from proiecte_etape where  isnull(inactiv,0) !=@p1 order by durata_pana_la asc `
        let u = new Utils();
        let etape = await ws.customSelect(
            `select e.*, u.* 
            from proiecte_etape e 
            left outer join useri u 
            on (e.id_user_responsabil = u.id) where isnull(e.inactiv,0) !=1 order by e.durata_pana_la asc`

            , {
                p1: 1
            })

        //console.log('etape :', etape);
        if (etape.Succes) {

            let cloneEtape = [...etape.Content]

            let counter = cloneEtape.length

            for (let i = 0; i < counter; i++) {
                cloneEtape[i].durata_de_la = u.ParseDataFromSql(cloneEtape[i].durata_de_la)
                cloneEtape[i].durata_pana_la = u.ParseDataFromSql(cloneEtape[i].durata_pana_la)
            }
            return etape.Content
        }
    }


    getTaskuriAll = async () => {
        let ws = new Ws();

        let u = new Utils();

        let taskuri = await ws.customSelect('select t.*, u.* from taskuri t left outer join useri u on (t.id_utilizator_responsabil = u.id) where t.id_etapa_proiect in (select id from proiecte_etape where isnull(inactiv, 0) != @p1) and isnull(t.inactiv,0) !=1 order by t.cand_data asc', {
            p1: 1
        })


        if (taskuri.Succes) {

            let cloneTaskuri = [...taskuri.Content]

            let counter = cloneTaskuri.length

            for (let i = 0; i < counter; i++) {
                cloneTaskuri[i].durata_de_la = u.ParseDataFromSql(cloneTaskuri[i].durata_de_la)
                cloneTaskuri[i].durata_pana_la = u.ParseDataFromSql(cloneTaskuri[i].durata_pana_la)
            }
            return taskuri.Content
        }
    }




    getEtape = async (id) => {
        let ws = new Ws();

        let u = new Utils();
        //  'select id, id_proiect, note, durata_de_la, durata_pana_la, id_user_responsabil, denumire, statusul from proiecte_etape where id_proiect = @p1 and isnull(inactiv,0) !=1 ',{

        let etape = await ws.customSelect(

            `select e.*, u.email,u.telefon, a.* from proiecte_etape e left outer join useri u 
                                                    on (e.id_user_responsabil = u.id)
                                                    left outer join angajati a on(u.id = a.id_user)
                                                     where e.id_proiect = @p1 and  isnull(e.inactiv,0) !=1 order by e.durata_de_la asc `,

            { p1: id }
        )

        // console.warn('etape first blood :', etape);
        if (etape.Succes) {

            let cloneEtape = [...etape.Content]

            let counter = cloneEtape.length

            for (let i = 0; i < counter; i++) {
                cloneEtape[i].durata_de_la = u.ParseDataFromSql(cloneEtape[i].durata_de_la)
                cloneEtape[i].durata_pana_la = u.ParseDataFromSql(cloneEtape[i].durata_pana_la)
            }



            // console.warn('etapeContent :', etape.Content);
            return etape.Content
        }
    }

    getTaskuri = async (id) => {
        let ws = new Ws();

        let u = new Utils();

        let taskuri = await ws.customSelect(`select t.*, u.email,u.telefon, a.* from taskuri t left outer join useri u 
                                                    on (t.id_utilizator_responsabil = u.id)
                                                    left outer join angajati a on(u.id = a.id_user)
                                                     where t.id_proiect = @p1 and t.id_etapa_proiect in 
                                                     (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv, 0) != 1) and isnull(t.id_task_parent, 0) = 0
                                                      and  isnull(t.inactiv,0) !=1 order by t.cand_data asc`, {
            p1: id
        })

        //console.log('taskuri :', taskuri);
        if (taskuri.Succes) {

            let cloneTaskuri = [...taskuri.Content]

            let counter = cloneTaskuri.length

            for (let i = 0; i < counter; i++) {
                cloneTaskuri[i].durata_de_la = u.ParseDataFromSql(cloneTaskuri[i].durata_de_la)
                cloneTaskuri[i].durata_pana_la = u.ParseDataFromSql(cloneTaskuri[i].durata_pana_la)
            }
            return taskuri.Content
        }
    }



    getTaskuriAndTaskuriParent = async (id) => {
        let ws = new Ws();

        let u = new Utils();

        let taskuri = await ws.customSelect(`select t.*, u.email,u.telefon, a.* from taskuri t left outer join useri u 
                                                    on (t.id_utilizator_responsabil = u.id)
                                                    left outer join angajati a on(u.id = a.id_user)
                                                     where t.id_proiect = @p1 and t.id_etapa_proiect in 
                                                     (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv, 0) != 1) 
                                                      and  isnull(t.inactiv,0) !=1 order by t.cand_data asc`, {
            p1: id
        })

        //console.log('taskuri :', taskuri);
        if (taskuri.Succes) {

            let cloneTaskuri = [...taskuri.Content]

            let counter = cloneTaskuri.length

            for (let i = 0; i < counter; i++) {
                cloneTaskuri[i].durata_de_la = u.ParseDataFromSql(cloneTaskuri[i].durata_de_la)
                cloneTaskuri[i].durata_pana_la = u.ParseDataFromSql(cloneTaskuri[i].durata_pana_la)
            }
            return taskuri.Content
        }
    }

    getSituatiiGenerale = async (id) => {
        let ws = new Ws();

        let proiect = ws.proc('rap_proiect_overview', { p1: id })

        let etape = ws.proc('rap_proiect_etape_overview', { p1: id })

        let [p, e] = await Promise.all([proiect, etape])


        if (p.Succes, e.Succes) {
            return [p.Content, e.Content]
        }
    }

    getSubTaskuri = async (id) => {
        let ws = new Ws();

        let u = new Utils();

        let taskuri = await ws.customSelect(`select t.*, u.email,u.telefon, a.* from taskuri t left outer join useri u 
                                            on (t.id_utilizator_responsabil = u.id)
                                            left outer join angajati a on(u.id = a.id_user)
                                            where t.id_proiect = @p1 and t.id_etapa_proiect in 
                                            (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv, 0) != 1) and isnull(t.id_task_parent, 0) != 0
                                                and  isnull(t.inactiv,0) !=1 order by t.cand_data asc`, {
            p1: id
        })

        //console.log('taskuri :', taskuri);
        if (taskuri.Succes) {

            let cloneTaskuri = [...taskuri.Content]

            let counter = cloneTaskuri.length

            for (let i = 0; i < counter; i++) {
                cloneTaskuri[i].durata_de_la = u.ParseDataFromSql(cloneTaskuri[i].durata_de_la)
                cloneTaskuri[i].durata_pana_la = u.ParseDataFromSql(cloneTaskuri[i].durata_pana_la)
            }
            return taskuri.Content
        }
    }




    insertEtapa = async (obj) => {
        let ws = new Ws();

        let insert = await ws.insert('proiecte_etape', obj)

        //console.log('insert :', insert);

        if (insert.Succes) {
            return insert
        }
    }

    insertTask = async (obj) => {
        let ws = new Ws();

        let insert = await ws.insert('taskuri', obj)

        //console.log('insert :', insert);


        obj = { success: false, content: [] }
        if (insert.Succes) {
            obj.success = true
            obj.content = insert.Content
            return obj
        }
    }


    updateTask = async (obj, id) => {
        let ws = new Ws();

        let update = await ws.update('taskuri', obj, { id: id })

        //console.log('update :', update);

        if (update.Succes) {
            return true
        }
    }


    updateEtapa = async (obj, id) => {
        let ws = new Ws();

        let update = await ws.update('proiecte_etape', obj, { id: id })

        //console.log('update :', update);

        if (update.Succes) {
            return true
        }
    }

    saveInformatiiProiect = async (obj, id) => {

        let ws = new Ws();

        let save = await ws.update('proiecte', obj, { id: id })



        if (save.Succes) {
            return save
        }
    }

    insertProject = async (obj) => {

        let ws = new Ws();

        let insert = await ws.insert('proiecte', obj)


        let rez = { success: false, obj: [] }

        if (insert.Succes) {
            rez.success = true
            rez.obj = insert.Content

            //console.log('rez :', rez);
            return rez
        }

    }




}